import React, { useCallback, useRef, useState } from 'react';
import { connect } from 'react-redux';
import Interactive from "react-interactive";

import { IAppState } from 'types/app';
import { MAP_BASE_URL } from 'components/Map/constants';
import { IArea } from 'types/map';
import { areaToTooltipData } from 'components/Map/util';
import asStateAwareArea from 'mapping/asStateAwareArea';
import Tooltip from './Lodgings/Tooltip';
import { openModalTooltip } from 'actions/modalTooltip';

interface Props {
  areas?: IArea[],
  avatarImage: string,
  currentArea?: IArea,
  dispatch: Function,
}

const noop = () => {
};

export function Limbo(props: Props) {
  const { areas, currentArea, dispatch } = props;

  const ref = useRef<HTMLDivElement>(null);
  const [isTooltipActive, setIsTooltipActive] = useState(false);

  const tooltipData = {
    ...areaToTooltipData(asStateAwareArea(currentArea!, areas || [], currentArea), currentArea, noop, true),
    name: `Your location: ${currentArea?.name}`,
  };

  const handleStateChange = useCallback(({ nextState, event }) => {
    event.preventDefault();
    const { iState } = nextState;
    const isHovering = /hover/.test(iState);
    setIsTooltipActive(isHovering);

    if (/touchActive/.test(iState)) {
      dispatch(openModalTooltip(tooltipData));
    }
  }, [dispatch, tooltipData]);

  return (
    <div
      className="map-limbo"
      ref={ref}
    >
      <PlayerMarker {...props} />
      <Interactive
        as="div"
        onStateChange={handleStateChange}
      >
        <SignpostIcon />
        <Tooltip
          parent={ref.current!}
          description={currentArea?.description ?? ''}
          isTooltipActive={isTooltipActive}
          tooltipData={tooltipData}
          tooltipPos="top"
        />
      </Interactive>
    </div>
  )
}

function PlayerMarker({ avatarImage }: Props) {
  return (
    <img
      alt="Player marker"
      className="map-limbo__player-marker"
      src={`${MAP_BASE_URL}/playermarkers/${avatarImage}-player-marker.png`}
    />
  );
}

function SignpostIcon() {
  return (
    <img
      alt="In limbo"
      className="map-limbo__signpost"
      src={"/map/signpost-icon.png"}
    />
  );
}

const mapStateToProps = ({
  map: { areas, currentArea },
  myself: {
    character: { avatarImage },
  }
}: IAppState) => ({
  areas,
  avatarImage,
  currentArea,
});

export default connect(mapStateToProps)(Limbo);